import type { Attribute } from '@tiptap/core';

export enum ETableCellVerticalAlignment {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom',
}

export const VERTICAL_ALIGN_ATTRIBUTE = 'verticalAlign';

const VERTICAL_ALIGN_HTML_ATTRIBUTE = 'data-vertical-align';

export const verticalAlignAttribute = (): Record<typeof VERTICAL_ALIGN_ATTRIBUTE, Attribute> => ({
  [VERTICAL_ALIGN_ATTRIBUTE]: {
    default: null,
    parseHTML: (element) => element.getAttribute(VERTICAL_ALIGN_HTML_ATTRIBUTE),
    renderHTML: (attributes) => {
      if (!attributes[VERTICAL_ALIGN_ATTRIBUTE]) return {};
      return { [VERTICAL_ALIGN_HTML_ATTRIBUTE]: attributes[VERTICAL_ALIGN_ATTRIBUTE] };
    },
  },
});

/**
 * Tiptap v3 writes header alignment as inline text-align; lists use the app's `data-align` so the
 * marker and the content move as one block.
 */
export const alignAttribute = (): Record<'align', Attribute> => ({
  align: {
    default: null,
    parseHTML: (element) =>
      element.getAttribute('data-align') || element.style.textAlign || element.getAttribute('align'),
    renderHTML: (attributes) => {
      if (!attributes.align) return {};
      return { 'data-align': attributes.align };
    },
  },
});

export const textRotationAttribute = (): Record<'textRotation', Attribute> => ({
  textRotation: {
    default: null,
    parseHTML: (element) => element.getAttribute('data-text-rotation'),
    renderHTML: (attributes) => {
      if (!attributes.textRotation) return {};
      return { 'data-text-rotation': attributes.textRotation };
    },
  },
});
